import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { faCircleNotch } from "@fortawesome/pro-solid-svg-icons";
import { GlobalHeaderDataService } from "../global-header-data.service";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { AppService } from "src/app/app.service";
import { SetNotificationSettings } from "src/app/store/actions/global-header.actions";
import {
  VAIconRegistryService,
  arrowToBottom,
  exclamationTriangle,
} from "@va/core-library/icons";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-global-notification",
  templateUrl: "./global-notification.component.html",
  styleUrls: ["./global-notification.component.scss"],
})
export class GlobalNotificationComponent {
  loading = false;
  faCircleNotch = faCircleNotch;
  apiUrl: string = window.apiUrl;
  successtag = "SUCCESS";
  failuretag = "FAILURE";
  processtag = "INPROGRESS";
  notificationList = [];
  panelHeader = "";
  tabHeaderText = "";
  tabDurationText = "";
  downloadBadgeDot = false;
  notificationHost: string;
  userId: number;
  legacyUrl = `${window.caUrl}/app`;
  isNotificationDropdown: boolean;
  isExcelNotification: boolean;
  isDownloadNotificationDDOpen = false;

  constructor(
    private store: Store<AppState>,
    private dataService: GlobalHeaderDataService,
    private router: Router,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([arrowToBottom, exclamationTriangle]);
  }

  ngOnInit() {
    this.store
      .select(stateGetter("globalHeader", "notificationSettings"))
      .subscribe((data: any) => {
        this.notificationHost = data.notificationHost;
        this.userId = data.userId;
        if (this.notificationHost && this.userId && data.fetchNewData) {
          this.dataService
            .getDownloadCount(this.notificationHost, this.userId)
            .subscribe(
              (response) => {
                this.downloadBadgeDot =
                  response.count && Number(response.count) ? true : false;
                this.store.dispatch(
                  new SetNotificationSettings({ fetchNewData: false }),
                );
              },
              () => {
                console.error("Failed while fetching Download count");
                this.store.dispatch(
                  new SetNotificationSettings({ fetchNewData: false }),
                );
              },
            );
        }
      });
    this.router.events.subscribe(() => {
      this.isDropdownOpen(false);
    });
  }

  getNotificationDetails = (type: string) => {
    this.loading = true;
    if (type === "Excel") {
      this.isExcelNotification = true;
    } else {
      this.isExcelNotification = false;
    }
    this.notificationList = [];
    this.tabHeaderText = "";
    this.tabDurationText = "";
    this.dataService.getActivityNotificationData(type).subscribe(
      (respObject) => {
        this.loading = false;
        if (this.isExcelNotification) {
          this.dataService
            .resetDownloadCount(this.notificationHost, this.userId)
            .subscribe();
          this.downloadBadgeDot = false;
        }
        this.notificationList = respObject.values;
        if (type === "Notifications") {
          this.tabHeaderText = "Notifications";
          this.tabDurationText = "Last 24-hours of Activity";
          this.appService.logUserAction(
            "notificationevent",
            "",
            "",
            "USER_NOTIFICATIONS",
            { UTCTIME: new Date().toUTCString(), URL: window.location.href },
            "",
            "",
          );
        } else {
          this.tabHeaderText = "Exports";
          this.tabDurationText =
            "Files you requested for download in the last 7 days";
          this.appService.logUserAction(
            "notificationevent",
            "",
            "",
            "USER_DOWNLOADS",
            { UTCTIME: new Date().toUTCString(), URL: window.location.href },
            "",
            "",
          );
        }
      },
      (errObject) => {
        console.error(errObject);
      },
    );
  };

  getEventName = (eventName: string, extras: any) => {
    const parsedExtra = JSON.parse(extras);
    let name = eventName;
    if (parsedExtra && parsedExtra.export_type === "tear_sheet") {
      name =
        parsedExtra.tear_sheet_type !== void 0
          ? parsedExtra.tear_sheet_type
          : "Tearsheet";
    } else if (parsedExtra.export_type === "surprise_export") {
      name = "Surprise Export";
    } else if (parsedExtra.export_type === "revision_export") {
      name = "Revision Export";
    } else if (parsedExtra.export_type === "research_download") {
      name = "Research Export";
    } else if (parsedExtra.export_type === "line_item_monitor") {
      name = "Line Item Monitor Export";
    } else if (parsedExtra.export_type === "vs_consensus") {
      name = "VS Consensus Export";
    }
    return name;
  };
  onRowClick(event, obj) {
    if (
      (this.getExcelStatus(this.successtag, obj.extras) &&
        this.checkIfPreAndPost(obj.extras)) ||
      (this.getExcelStatus(this.successtag, obj.extras) &&
        !this.checkIfPreAndPost(obj.extras))
    ) {
      this.excelNotificationDownload(event, obj.actor.actor_text, obj.extras);
    } else if (
      this.getExcelStatus(this.failuretag, obj.extras) &&
      this.getRetryStatus(obj.extras)
    ) {
      this.retryDownload(obj.actor.actor_text, obj.extras);
    }
  }
  getExcelStatus = (type: string, extras: any) => {
    const extrasJSON = JSON.parse(extras);
    return type === extrasJSON.status.toUpperCase();
  };

  getRetryStatus = (extras: any) => {
    const parsedExtra = JSON.parse(extras);
    return parsedExtra.retryflag;
  };

  checkIfPreAndPost = function (extras: any) {
    const extrasJSON = JSON.parse(extras);
    if (extrasJSON.export_type === "tear_sheet") {
      return true;
    }
    return false;
  };

  iFrameCallBack = (excelTrackerId: any) => {
    let res =
      frames[`excel_download_${excelTrackerId}`].document.getElementsByTagName(
        "body",
      )[0].innerHTML;
    if (res) {
      res = JSON.parse(res);
      if (res.status === "error") {
        //alert(res["message"]);
        // console.log('Failed to download file, ' + res['filename'] + ' for source ' + source + '.')
      }
    }
    setTimeout(function () {
      // $('#excel_download_' + excelTrackerId).remove();
      document.getElementById(`excel_download_${excelTrackerId}`).remove();
    }, 100);
  };

  excelNotificationDownload = (event: any, ticker: string, extras: any) => {
    const extrasJSON = JSON.parse(extras);
    const excelTrackerId = extrasJSON.trackerId;
    const extraParams = {
      event: event,
      tickerName: ticker,
      excelTrackerId: excelTrackerId,
      actionSource: "NOTIFICATION_PANEL",
    };

    this.appService.excelDownload(extrasJSON.export_type, extraParams);

    // let url = "";
    // if (extrasJSON.export_type === "tear_sheet") {
    //   this.appService.logUserAction(
    //     event,
    //     ticker,
    //     "",
    //     "TEAR_SHEET_DOWNLOAD",
    //     { trackerId: excelTrackerId },
    //     "",
    //     "NOTIFICATION_PANEL"
    //   );
    // }
    // url = `${this.apiUrl}/api/excel_file_download?exceltrackerid=${excelTrackerId}`;
    // if (extrasJSON.export_type === "research_download") {
    //   url = `${this.apiUrl}/api/downloadresearchzip?exceltrackerid=${excelTrackerId}`;
    // }

    // //TO-DO: change id name from excel, to research, for the research downloads
    // const iFrame = document.createElement("iframe");
    // iFrame.setAttribute("id", `excel_download_${excelTrackerId}`);
    // iFrame.setAttribute("name", `excel_download_${excelTrackerId}`);
    // iFrame.setAttribute("style", "visibility:hidden;display:none;");

    // document.body.appendChild(iFrame);
    // iFrame.addEventListener(
    //   "load",
    //   this.iFrameCallBack.bind(excelTrackerId),
    //   true
    // );
    // iFrame.setAttribute("src", url);
  };

  retryDownload = (ticker: string, extras: any) => {
    this.dataService.retryExcelDownload(ticker, extras).subscribe();
  };

  isDropdownOpen(isOpen: boolean) {
    this.isNotificationDropdown = isOpen;
  }

  onHelp() {
    this.appService.logUserAction(
      "helpevent",
      "",
      "",
      "USER_HELP",
      { UTCTIME: new Date().toUTCString(), URL: window.location.href },
      "",
      "",
    );
    setTimeout(() => {
      window.open(environment.SUPPORT_LINKS.base_link, "_blank");
    }, 300);
  }

  openDownloadNotification(isOpen: boolean) {
    this.isDownloadNotificationDDOpen = isOpen;
  }
  // ngOnInit() {}
}
